export type LabStatus = 'live' | 'comingSoon';

const implementedPracticalSlugs = new Set([
  'qualitative-analysis-salt-analysis',
  'acid-base-titration',
  'volumetric-analysis-redox-titrations',
  'tests-for-gases',
  'measurement-and-units',
  'simple-pendulum',
  'hookes-law-spring-experiment',
  'ohms-law',
  'refraction-through-glass-block',
  'microscopy',
  'classification-of-living-organisms',
  'food-tests',
]);

export const getDefaultLabStatus = (slug?: string): LabStatus =>
  slug && implementedPracticalSlugs.has(slug.toLowerCase()) ? 'live' : 'comingSoon';

export const getLabStatus = (lab: { status?: string; slug?: string }): LabStatus => {
  if (lab.status === 'live' || lab.status === 'active' || lab.status === 'comingSoon') {
    return lab.status === 'active' ? 'live' : lab.status;
  }
  return getDefaultLabStatus(lab.slug);
};